import type { Http } from '../http';
import { endpoints } from '../endpoints';
import type { RawGetEventsParams, RawEventsResponse } from '../types/event';
import type { RequestOptions } from '../types/common';

export function createEventApi(http: Http) {
  return {
    async list(params?: RawGetEventsParams, options?: RequestOptions): Promise<RawEventsResponse> {
      const res = await http.get<RawEventsResponse>(endpoints.event.base, {
        params,
        signal: options?.signal,
      });
      return res.data;
    },
  };
}
